import React from 'react';
import { Redirect } from 'react-router';

import { OAUTH2_REDIRECT_TO_KEY } from 'utils/constants';

export const Oauth2Page = () => {
  const redirectTo = localStorage.getItem(OAUTH2_REDIRECT_TO_KEY);

  if (redirectTo) {
    localStorage.removeItem(OAUTH2_REDIRECT_TO_KEY);

    return <Redirect to={redirectTo} />;
  }

  return <Redirect to="/" />;
};
